<script lang="ts">
	import  FileDrop from "filedrop-svelte";
	import type {Files}  from "filedrop-svelte";
	import type {FileWithPath} from "file-selector";
	import ListItem from "./ListItem.svelte";
	import {ASSET_URL} from "../config";
	import { _ } from '../services/i18n.js';


	export let files: FileWithPath[] = [];
	export let accept: string = '';
	export let max: number;
	export let maxSize: number;

	let dropping = false;

	function onFiles(f: Files) {
		dropping = false;
		console.log("files:");
		console.log(f);
		//heic convertion here:
		/*
		for (const file of files) {
      const newName = changeExtension(file, ".heic", ".jpeg");
      const converted = (await heic2any({
        blob: file,
        toType: "image/jpeg",
      })) as Blob;
		 */
		files = files.concat(f.accepted);
	}

	function a11yUpload(){

		console.log("handle upload here....");
	}

</script>

{#each files as file}
	<ListItem on:remove={() => files = files.filter(f => f !== file)} name={file.path}>
		{file.path}
	</ListItem>
{/each}

{#if files.length < max}
	<FileDrop {accept} fileLimit={max - files.length} {maxSize} on:filedrop={e => onFiles(e.detail.files)}
			  on:dragenter={() => dropping = true} on:dragover={() => dropping = true} on:dragleave={() => dropping = false}>
		<div style="cursor: pointer" class="file-drop-box" class:dropping>
			<div>
				<!-- new solution issues with dropzone js:
				<input id="file-upload-btn" type="file" class="file-button" tabindex="-1"/>
				<label for="file-upload-btn">{$_('stepContent.chooseFile')}</label>
				-->
				<button class="file-button" tabindex="-1" type="button">{$_('stepContent.chooseFile')}</button>

				<!--
				<label class="file-button" tabindex="-1" for="fileupload">{$_('stepContent.chooseFile')}</label>
				<input class="a11y-upload" id="fileupload" type="file" on:click|preventDefault={a11yUpload} />
				-->

			</div>
			<div class="file-drop-info">
				<span class="file-info-text">{$_('stepContent.dragFileHere')}</span>
				<img alt="" src="{ASSET_URL}/assets/download.svg">
			</div>
		</div>
	</FileDrop>
{/if}

<style lang="scss">

	.a11y-upload{
		color: transparent;
	}

    /* 600px, 900px, 1200px, and 1800px */
    @media (max-width: 900px) {
		.file-drop-box {
			div {
	            width: 100%;
	        }
		}
    }
	.file-drop-box {
		display: flex;
	    flex-wrap: wrap;
		border: 2px dashed black;
		transition: border-color 200ms;
		border-radius: 14px;

		padding: 30px 40px;

		&.dropping {
			border-color: #808080;
		}

		div {
			width: 50%;
		    min-width: fit-content;
		}

		.file-drop-info {
			display: flex;
			flex-direction: column;
			justify-content: center;

			.file-info-text {
				//font-family: 'Poppins', sans-serif;
				font-family: 'Open Sans', sans-serif;
				font-size: 16px;
				font-weight: 700;
				line-height: 24px;
				letter-spacing: 0;

				text-align: center;
				color: black;
				margin-bottom: 15px;
			}

			img {
				margin: 0;
				height: 25px;
			}
		}

		.file-button {
			all: unset;
			border: 1px solid black;
			border-radius: 5px;
			padding: 10px;
			font-weight: bold;
		}
	}
	:global(.file-upload-container > label:focus .file-drop-box) {
		border-color: var(--focus-color);
	}
</style>
